module.exports = __webpack_public_path__ + "static/fonts/fontello.7c436b7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/fontello/font/fontello.ttf?32974303
// module id = I1Rj
// module chunks = 20